// Purchase Cycle Management Data
// Comprehensive data for all purchase workflow phases

// Inventory Management Data
export const inventoryData = {
  // Current inventory levels
  currentInventory: [
    {
      id: 'INV-001',
      itemCode: 'RM-001',
      itemName: '鋼材板 A36',
      itemNameEn: 'Steel Plate A36',
      category: 'raw_materials',
      currentStock: 850,
      unit: 'kg',
      safetyStock: 200,
      reorderLevel: 300,
      maxStock: 1500,
      unitCost: 45.50,
      totalValue: 38675,
      lastUpdated: '2024-01-25T10:30:00Z',
      location: 'WH-A-001',
      supplier: 'SUP-001',
      supplierName: '東亞鋼鐵供應商',
      leadTime: 7,
      status: 'adequate',
      image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&h=300&fit=crop'
    },
    {
      id: 'INV-002',
      itemCode: 'RM-002',
      itemName: '鋁合金管 6061',
      itemNameEn: 'Aluminum Tube 6061',
      category: 'raw_materials',
      currentStock: 120,
      unit: 'm',
      safetyStock: 50,
      reorderLevel: 80,
      maxStock: 500,
      unitCost: 125.00,
      totalValue: 15000,
      lastUpdated: '2024-01-25T09:15:00Z',
      location: 'WH-A-002',
      supplier: 'SUP-002',
      supplierName: '華南鋁業',
      leadTime: 5,
      status: 'reorder_needed',
      image: 'https://images.unsplash.com/photo-1587293852726-70cdb56c2866?w=400&h=300&fit=crop'
    },
    {
      id: 'INV-003',
      itemCode: 'CP-001',
      itemName: '電子控制器 MCU-100',
      itemNameEn: 'Electronic Controller MCU-100',
      category: 'components',
      currentStock: 45,
      unit: 'pcs',
      safetyStock: 20,
      reorderLevel: 30,
      maxStock: 200,
      unitCost: 350.00,
      totalValue: 15750,
      lastUpdated: '2024-01-25T08:45:00Z',
      location: 'WH-B-001',
      supplier: 'SUP-003',
      supplierName: '新科技電子',
      leadTime: 14,
      status: 'reorder_needed',
      image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=400&h=300&fit=crop'
    },
    {
      id: 'INV-004',
      itemCode: 'RM-003',
      itemName: '不銹鋼螺栓 M8x25',
      itemNameEn: 'Stainless Steel Bolt M8x25',
      category: 'fasteners',
      currentStock: 2500,
      unit: 'pcs',
      safetyStock: 500,
      reorderLevel: 800,
      maxStock: 5000,
      unitCost: 2.50,
      totalValue: 6250,
      lastUpdated: '2024-01-25T11:20:00Z',
      location: 'WH-C-001',
      supplier: 'SUP-004',
      supplierName: '精密五金',
      leadTime: 3,
      status: 'adequate',
      image: 'https://images.unsplash.com/photo-1609205807107-e0d2b6d1b9d7?w=400&h=300&fit=crop'
    },
    {
      id: 'INV-005',
      itemCode: 'RM-004',
      itemName: '橡膠密封圈 O-Ring 50mm',
      itemNameEn: 'Rubber O-Ring 50mm',
      category: 'seals',
      currentStock: 180,
      unit: 'pcs',
      safetyStock: 100,
      reorderLevel: 150,
      maxStock: 800,
      unitCost: 8.50,
      totalValue: 1530,
      lastUpdated: '2024-01-25T12:00:00Z',
      location: 'WH-C-002',
      supplier: 'SUP-005',
      supplierName: '環球橡膠',
      leadTime: 10,
      status: 'reorder_needed',
      image: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=400&h=300&fit=crop'
    }
  ],

  // Inventory dashboard summary
  inventoryDashboard: {
    totalItems: 5,
    totalValue: 77205,
    lowStockItems: 3,
    reorderItems: 3,
    adequateItems: 2,
    overStockItems: 0,
    turnoverRate: 4.2,
    averageLeadTime: 7.8,
    stockAccuracy: 98.5,
    warehouseUtilization: 72.3,
    monthlyConsumption: 18350,
    stockoutRisk: 'medium',
    categories: [
      { name: 'raw_materials', count: 3, value: 69425 },
      { name: 'components', count: 1, value: 15750 },
      { name: 'fasteners', count: 1, value: 6250 },
      { name: 'seals', count: 1, value: 1530 }
    ]
  }
};

// MRP Planning Data
export const mrpData = {
  // MRP calculation results
  mrpCalculations: [
    {
      id: 'MRP-2024-001',
      planningHorizon: '2024-02-01 to 2024-03-31',
      calculationDate: '2024-01-25T14:00:00Z',
      status: 'completed',
      totalItems: 15,
      totalRequirement: 125000,
      totalPlannedOrders: 8,
      items: [
        {
          itemCode: 'RM-001',
          itemName: '鋼材板 A36',
          currentStock: 850,
          grossRequirement: 2500,
          netRequirement: 1650,
          plannedOrderQty: 2000,
          plannedOrderDate: '2024-02-05',
          leadTime: 7,
          suggestedAction: 'place_order',
          priority: 'high'
        },
        {
          itemCode: 'RM-002',
          itemName: '鋁合金管 6061',
          currentStock: 120,
          grossRequirement: 800,
          netRequirement: 680,
          plannedOrderQty: 1000,
          plannedOrderDate: '2024-02-01',
          leadTime: 5,
          suggestedAction: 'place_order',
          priority: 'urgent'
        },
        {
          itemCode: 'CP-001',
          itemName: '電子控制器 MCU-100',
          currentStock: 45,
          grossRequirement: 200,
          netRequirement: 155,
          plannedOrderQty: 200,
          plannedOrderDate: '2024-02-03',
          leadTime: 14,
          suggestedAction: 'place_order',
          priority: 'high'
        }
      ]
    }
  ],

  // MRP dashboard summary
  mrpDashboard: {
    totalPlannedOrders: 8,
    urgentOrders: 2,
    highPriorityOrders: 3,
    mediumPriorityOrders: 2,
    lowPriorityOrders: 1,
    totalValue: 125000,
    averageLeadTime: 8.5,
    onTimeDeliveryRate: 94.2,
    planningAccuracy: 96.8,
    lastCalculation: '2024-01-25T14:00:00Z',
    nextCalculation: '2024-01-26T14:00:00Z',
    planningCycle: 'daily',
    demandForecast: [
      { month: '2024-02', demand: 65000 },
      { month: '2024-03', demand: 72000 },
      { month: '2024-04', demand: 68000 }
    ]
  }
};

// Budget Control Data
export const budgetData = {
  // Budget allocations
  budgetAllocations: [
    {
      id: 'BUD-2024-001',
      department: 'production',
      departmentName: '生產部門',
      category: 'raw_materials',
      categoryName: '原物料',
      budgetYear: 2024,
      budgetMonth: 2,
      allocatedAmount: 500000,
      spentAmount: 125000,
      remainingAmount: 375000,
      utilizationRate: 25.0,
      status: 'active',
      approver: 'manager_001',
      approverName: '王生產經理',
      approvalDate: '2024-01-01T00:00:00Z',
      lastUpdated: '2024-01-25T16:30:00Z'
    },
    {
      id: 'BUD-2024-002',
      department: 'production',
      departmentName: '生產部門',
      category: 'components',
      categoryName: '零組件',
      budgetYear: 2024,
      budgetMonth: 2,
      allocatedAmount: 300000,
      spentAmount: 85000,
      remainingAmount: 215000,
      utilizationRate: 28.3,
      status: 'active',
      approver: 'manager_001',
      approverName: '王生產經理',
      approvalDate: '2024-01-01T00:00:00Z',
      lastUpdated: '2024-01-25T16:30:00Z'
    },
    {
      id: 'BUD-2024-003',
      department: 'maintenance',
      departmentName: '維護部門',
      category: 'spare_parts',
      categoryName: '備品備料',
      budgetYear: 2024,
      budgetMonth: 2,
      allocatedAmount: 150000,
      spentAmount: 35000,
      remainingAmount: 115000,
      utilizationRate: 23.3,
      status: 'active',
      approver: 'manager_002',
      approverName: '李維護經理',
      approvalDate: '2024-01-01T00:00:00Z',
      lastUpdated: '2024-01-25T16:30:00Z'
    }
  ],

  // Budget dashboard summary
  budgetDashboard: {
    totalAllocated: 950000,
    totalSpent: 245000,
    totalRemaining: 705000,
    overallUtilization: 25.8,
    budgetVariance: -705000,
    departmentCount: 2,
    categoryCount: 3,
    activeAllocations: 3,
    expiredAllocations: 0,
    budgetAlerts: [
      {
        type: 'warning',
        message: '生產部門零組件預算使用率偏高',
        allocation: 'BUD-2024-002',
        utilizationRate: 28.3
      }
    ],
    monthlyTrend: [
      { month: '2024-01', spent: 185000, allocated: 950000 },
      { month: '2024-02', spent: 245000, allocated: 950000 }
    ]
  }
};

// Contract Management Data
export const contractData = {
  // Purchase contracts
  purchaseContracts: [
    {
      id: 'CON-2024-001',
      contractNumber: 'PC-2024-001',
      contractName: '鋼材供應框架合約',
      contractNameEn: 'Steel Supply Framework Contract',
      supplier: 'SUP-001',
      supplierName: '東亞鋼鐵供應商',
      contractType: 'framework',
      contractValue: 2500000,
      currency: 'TWD',
      startDate: '2024-01-01',
      endDate: '2024-12-31',
      status: 'active',
      paymentTerms: 'NET30',
      deliveryTerms: 'FOB',
      qualityRequirements: 'ASTM A36 標準',
      penaltyClause: '延遲交貨每日罰款 0.1%',
      warrantyPeriod: '12個月',
      contractItems: [
        {
          itemCode: 'RM-001',
          itemName: '鋼材板 A36',
          unitPrice: 45.50,
          minQuantity: 1000,
          maxQuantity: 10000,
          leadTime: 7
        }
      ],
      milestones: [
        {
          id: 'MS-001',
          description: '合約簽署',
          dueDate: '2024-01-01',
          status: 'completed',
          completionDate: '2024-01-01'
        },
        {
          id: 'MS-002',
          description: '首批交貨',
          dueDate: '2024-01-15',
          status: 'completed',
          completionDate: '2024-01-14'
        }
      ],
      documents: [
        {
          type: 'contract',
          name: '主合約文件',
          url: '/documents/contracts/PC-2024-001-main.pdf'
        },
        {
          type: 'specification',
          name: '技術規格書',
          url: '/documents/contracts/PC-2024-001-spec.pdf'
        }
      ],
      createdBy: 'user_001',
      createdDate: '2024-01-01T00:00:00Z',
      lastModified: '2024-01-25T10:00:00Z'
    },
    {
      id: 'CON-2024-002',
      contractNumber: 'PC-2024-002',
      contractName: '電子零件供應合約',
      contractNameEn: 'Electronic Components Supply Contract',
      supplier: 'SUP-003',
      supplierName: '新科技電子',
      contractType: 'fixed',
      contractValue: 1200000,
      currency: 'TWD',
      startDate: '2024-02-01',
      endDate: '2024-07-31',
      status: 'pending_approval',
      paymentTerms: 'NET45',
      deliveryTerms: 'DDP',
      qualityRequirements: 'IPC-A-610 Class 2',
      penaltyClause: '品質不符每件罰款 100 元',
      warrantyPeriod: '24個月',
      contractItems: [
        {
          itemCode: 'CP-001',
          itemName: '電子控制器 MCU-100',
          unitPrice: 350.00,
          minQuantity: 100,
          maxQuantity: 1000,
          leadTime: 14
        }
      ],
      milestones: [
        {
          id: 'MS-003',
          description: '合約審核',
          dueDate: '2024-01-30',
          status: 'in_progress'
        }
      ],
      documents: [
        {
          type: 'draft',
          name: '合約草案',
          url: '/documents/contracts/PC-2024-002-draft.pdf'
        }
      ],
      createdBy: 'user_002',
      createdDate: '2024-01-20T00:00:00Z',
      lastModified: '2024-01-25T14:00:00Z'
    }
  ],

  // Contract dashboard summary
  contractDashboard: {
    totalContracts: 2,
    activeContracts: 1,
    pendingContracts: 1,
    expiredContracts: 0,
    totalValue: 3700000,
    averageContractValue: 1850000,
    contractsByType: [
      { type: 'framework', count: 1, value: 2500000 },
      { type: 'fixed', count: 1, value: 1200000 }
    ],
    contractsByStatus: [
      { status: 'active', count: 1, value: 2500000 },
      { status: 'pending_approval', count: 1, value: 1200000 }
    ],
    upcomingExpirations: [],
    pendingApprovals: ['CON-2024-002'],
    performanceMetrics: {
      onTimeDelivery: 95.5,
      qualityCompliance: 98.2,
      costSavings: 125000
    }
  }
};

// Approval Workflow Data
export const approvalWorkflowData = {
  // Approval workflows
  approvalWorkflows: [
    {
      id: 'AWF-001',
      workflowName: '採購訂單核准流程',
      workflowNameEn: 'Purchase Order Approval Workflow',
      description: '採購訂單金額核准流程',
      workflowType: 'purchase_order',
      isActive: true,
      approvalLevels: [
        {
          level: 1,
          levelName: '部門主管',
          approverRole: 'department_manager',
          requiredApprovers: 1,
          amountLimit: 100000,
          timeLimit: 24 // hours
        },
        {
          level: 2,
          levelName: '採購經理',
          approverRole: 'procurement_manager',
          requiredApprovers: 1,
          amountLimit: 500000,
          timeLimit: 48 // hours
        },
        {
          level: 3,
          levelName: '總經理',
          approverRole: 'general_manager',
          requiredApprovers: 1,
          amountLimit: null, // no limit
          timeLimit: 72 // hours
        }
      ],
      createdBy: 'admin_001',
      createdDate: '2024-01-01T00:00:00Z',
      lastModified: '2024-01-15T00:00:00Z'
    }
  ],

  // Pending approvals
  pendingApprovals: [
    {
      id: 'APP-2024-001',
      requestType: 'purchase_order',
      requestId: 'PO-2024-005',
      requestTitle: '採購訂單 PO-2024-005',
      requester: 'user_003',
      requesterName: '陳採購員',
      requestDate: '2024-01-25T09:00:00Z',
      amount: 125000,
      currency: 'TWD',
      currentLevel: 1,
      currentApprover: 'manager_001',
      currentApproverName: '王生產經理',
      status: 'pending',
      priority: 'normal',
      dueDate: '2024-01-26T09:00:00Z',
      description: '生產用鋼材採購',
      attachments: [
        {
          name: '採購申請單',
          url: '/documents/approvals/APP-2024-001-request.pdf'
        }
      ],
      approvalHistory: [
        {
          level: 1,
          approver: 'manager_001',
          approverName: '王生產經理',
          status: 'pending',
          assignedDate: '2024-01-25T09:00:00Z'
        }
      ]
    },
    {
      id: 'APP-2024-002',
      requestType: 'contract',
      requestId: 'CON-2024-002',
      requestTitle: '電子零件供應合約',
      requester: 'user_002',
      requesterName: '李採購專員',
      requestDate: '2024-01-24T14:00:00Z',
      amount: 1200000,
      currency: 'TWD',
      currentLevel: 2,
      currentApprover: 'manager_003',
      currentApproverName: '張採購經理',
      status: 'pending',
      priority: 'high',
      dueDate: '2024-01-26T14:00:00Z',
      description: '電子控制器年度供應合約',
      attachments: [
        {
          name: '合約草案',
          url: '/documents/approvals/APP-2024-002-contract.pdf'
        }
      ],
      approvalHistory: [
        {
          level: 1,
          approver: 'manager_001',
          approverName: '王生產經理',
          status: 'approved',
          assignedDate: '2024-01-24T14:00:00Z',
          approvedDate: '2024-01-25T10:00:00Z',
          comments: '技術規格確認無誤'
        },
        {
          level: 2,
          approver: 'manager_003',
          approverName: '張採購經理',
          status: 'pending',
          assignedDate: '2024-01-25T10:00:00Z'
        }
      ]
    }
  ],

  // Approval dashboard summary
  approvalDashboard: {
    totalPendingApprovals: 2,
    urgentApprovals: 0,
    highPriorityApprovals: 1,
    normalPriorityApprovals: 1,
    overdueApprovals: 0,
    averageApprovalTime: 18.5, // hours
    approvalsByType: [
      { type: 'purchase_order', count: 1, value: 125000 },
      { type: 'contract', count: 1, value: 1200000 }
    ],
    approvalsByLevel: [
      { level: 1, count: 1, avgTime: 12 },
      { level: 2, count: 1, avgTime: 24 },
      { level: 3, count: 0, avgTime: 36 }
    ],
    weeklyTrend: [
      { week: '2024-W03', submitted: 5, approved: 4, rejected: 0 },
      { week: '2024-W04', submitted: 3, approved: 2, rejected: 1 }
    ]
  }
};

// Purchase Cycle Dashboard Summary
export const purchaseCycleDashboard = {
  totalBudget: 950000,
  spentAmount: 245000,
  remainingBudget: 705000,
  budgetUtilization: 25.8,
  totalInventoryValue: 77205,
  lowStockItems: 3,
  plannedOrders: 8,
  urgentOrders: 2,
  activeContracts: 1,
  pendingApprovals: 2,
  recentActivities: [
    {
      id: 'ACT-001',
      type: 'inventory_alert',
      message: '鋁合金管 6061 庫存不足，需要補貨',
      timestamp: '2024-01-25T12:00:00Z',
      priority: 'high'
    },
    {
      id: 'ACT-002',
      type: 'approval_pending',
      message: '採購訂單 PO-2024-005 等待部門主管核准',
      timestamp: '2024-01-25T09:00:00Z',
      priority: 'normal'
    },
    {
      id: 'ACT-003',
      type: 'mrp_calculation',
      message: 'MRP 計算完成，產生 8 個計劃訂單',
      timestamp: '2024-01-25T14:00:00Z',
      priority: 'info'
    }
  ],
  keyMetrics: {
    inventoryTurnover: 4.2,
    stockAccuracy: 98.5,
    onTimeDelivery: 94.2,
    costSavings: 125000,
    approvalCycleTime: 18.5
  }
}; 